export default __webpack_public_path__ + "static/media/IconDesc_ChristmasTree.256.599a5668.png";